import Joi from 'joi';

const baseSchema = {
  email: Joi.string().required(),
  password: Joi.string().min(4).max(12).required(),
};

export const loginSchema = Joi.object({
  ...baseSchema,
});

export const registerSchema = Joi.object({
  ...baseSchema,
  userName: Joi.string().required(),
});

export const retrievePasswordSchema = Joi.object({
  userInput: Joi.string().required(),
});

export const resetPasswordSchema = Joi.object({
  password: Joi.string().min(4).max(12).required(),
  confirmPassword: Joi.string().valid(Joi.ref('password')).required(),
});
